export { formatRegionalCurrency as formatCurrency } from "./format-regional";
